import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../../../Building'

export function getBuildingLabel(option) {
  return option?.title
}

export function getListApiParams() {
  return BUILDING_OPTIONS_WITH_AVATAR_PARAMS
}
